import { has } from "lodash";
import { NEW_ID_PREFIX } from "utils/dictionary";

export const PROMPT_TYPES = {
  default: "Default",
  "selection based": "Selection Based",
};

export const PROMPT_DISPLAY_CONTEXTS = {
  MISC_ANALYSIS_WRITING_EDITING: "Misc Analysis - Writing & Editing",
  TRACKED_OPPORTUNITY_RESEARCH: "Tracked Opportunity - Research",
  PROPOSALS_WRITING_EDITING: "Proposals - Proposal Writing",
};

export const createEmptyCategory = (owner) => {
  const id = `${NEW_ID_PREFIX}-${Date.now()}`;

  return {
    id,
    categoryId: id,
    name: "",
    description: null,
    categoryType: "PRIVATE",
    shares: [],
    owner: owner,
    isOwner: true,
    canEdit: true,
    displayContexts: Object.keys(PROMPT_DISPLAY_CONTEXTS),
    collapsed: false,
    prompts: [],
    isNew: true,
  };
};

export const getIsCategory = (data) => has(data, "categoryType");

export const getIsPromptType = (data) => has(data, "promptType");

export const getDisplayName = (data) => {
  const isCategory = getIsCategory(data);

  return isCategory ? data.name : data.shortcut;
};

export const getOwnerByRow = (row) => {
  const category = row.getParentRow();
  return category?.original?.owner;
};

export const getIsRowDisabled = (row, currentUsername) => {
  if (!row?.original || !currentUsername) {
    return false;
  }

  const { original } = row;
  const isCategory = getIsCategory(original);
  const owner = isCategory ? original.owner : getOwnerByRow(row);

  return owner !== "System" && owner !== currentUsername;
};
